import { Component, OnInit, QueryList, ViewChildren, ViewChild } from '@angular/core';
import { PerfectScrollbarDirective, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AppSettings } from '../app.settings';
import { Settings } from '../app.settings.model';
import { AuthenticateService } from '../core/services/authenticate.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { FindTimeService } from '../core/services/find-time.service';
import { AppData } from '../app.data';





@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit {
  @ViewChildren(PerfectScrollbarDirective) pss: QueryList<PerfectScrollbarDirective>;  
  public optionsPsConfig: PerfectScrollbarConfigInterface = {};
  public settings: Settings;
  
  constructor(
    private appSettings: AppSettings, 
    private  authService: AuthenticateService,
    private findtimeService: FindTimeService,
    private translate: TranslateService, 
    private appData: AppData,
    private router: Router) {
      
    this.settings = appSettings.settings;
    this.settings.showHeaderButtons = true; //for test
  }

  ngOnInit() {
  }

  ngAfterViewInit(){
    this.settings.loadingSpinner = false;
  }

 

  logout(event) {
    
    this.authService.logout().subscribe(x => {
        if(x && x.Code === 1){
          // console.log("logout successfully");
          this.router.navigate(['/login']);
        } else {
          // console.log("logout failed for some reason but exit anyway");
          this.router.navigate(['/login']);
        }
    }, error => {
      // an error occured but exit anyway
      this.router.navigate(['/login']);
    });
  }

  findOpenSlot(){
    // clear previous saved values;
    this.appData.clearFindTimeData();
    this.appData.findTimeCancelButtonRoute = '/scheduler'; // set the findtime cancel button route to the scheduler
    this.router.navigate(['/find-time']);
  }



}
